import React from "react";
import Slider from "react-slick";

export const TRSlider = ({
  items = [],
  fade = true,
  autoplay = true,
  autoplaySpeed = 1800,
  dots = false,
  arrows = false,
  className = "",
  renderItem,
}) => {
  const settings = {
    dots,
    arrows,
    infinite: true,
    speed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay,
    autoplaySpeed,
    fade: true,
    adaptiveHeight: false,
    pauseOnHover: true,
    cssEase: "ease-in-out",
    useCSS: true,
    useTransform: true,
  };

  const defaultRenderer = (slide, index) => {
    return (
      <div key={index} className="hero-slide-item">
        <div className="hero-slide-bg">
          {slide.image ? (
            <img 
              src={slide.image} 
              alt={slide.title || `slide-${index + 1}`} 
              className="hero-slide-img"
              onError={(e) => {
                e.target.style.background = '#ccc';
              }}
            />
          ) : null}
          <div className="hero-slide-overlay"></div>
        </div>
        {(slide.title || slide.text) ? (
          <div className="hero-slide-caption">
            <div className="hero-slide-caption-inner">
              {slide.title ? (
                <h1 className="hero-slide-title">
                  {slide.title}
                </h1>
              ) : null}
              {slide.text ? (
                <p className="hero-slide-text">
                  {slide.text}
                </p>
              ) : null}
              {slide.ctaHref && slide.ctaText ? (
                <a 
                  href={slide.ctaHref} 
                  className="btn btn-custom btn-lg page-scroll hero-slide-btn"
                >
                  {slide.ctaText}
                </a>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className={`hero-slider ${className}`}>
      <Slider {...settings}>
        {items && items.length > 0
          ? items.map((slide, index) => (renderItem ? renderItem(slide, index) : defaultRenderer(slide, index)))
          : null}
      </Slider>
    </div>
  );
};

export default TRSlider; 